export default __webpack_public_path__ + "static/media/mobile2.907a4f93.jpg";